export const formulaLabelsConfig = {
  // "Box Inlet Drop
  width: { label: 'Width (ft)' },
  length: { label: 'Length (ft)' },
  headAboveWeir: { label: 'Head Above Weir (ft)', required: true },
  weirElevation: { label: 'Weir Elevation (ft)' },
  floorElevation: { label: 'Floor Elevation (ft)' },

  // Circular Section
  waterDepth: {
    required: true,
    label: 'Water Depth (in)',
    errorCode: 'Common_10',
  },
  pipeSlope: {
    required: true,
    label: 'Pipe Slope (ft/ft)',
    errorCode: 'Common_10',
    step: 0.0001,
    decimalPlaces: 4,
  }, 

  // Dry Hydrant
  waterNeeded: { label: 'Water Needed (gpm)', required: true, min: 250, max: 2000, errorCode: 'Formula_09' },

  dryHydrantElevationDto: { label: 'Elevations' },
  pumpCenterlineElev: { label: 'Pump Centerline Elevation (ft)', required: true },
  hydrantCenterlineElev: { label: 'Hydrant Centerline Elevation (ft)', required: true },
  normalWaterElev: { label: 'Normal Water Elevation (ft)', required: true },
  inletCenterlineElev: { label: 'Inlet Centerline Elevation (ft)', required: true },

  pipelineDto: { label: 'Pipeline' },
  totalPipeLength: { label: 'Total Pipe Length (ft)', required: true },
  hazenWilliamsCoeff: { label: 'Hazen-Williams Coefficient', required: true, errorCode: 'Common_10' },
  numberOf90Elbows: { label: 'Number of 90° Elbows' },
  numberOf45Elbows: { label: 'Number of 45° Elbows' },

  // Hooded Inlet
  hoodedInletElevationDto: { label: 'Elevations' },
  toeElev: { label: 'Toe Elevation (ft)' },
  auxSpillwayElev: { label: 'Auxiliary Spillway Elevation (ft)', required: true },
  waterElev: { label: 'Water Elevation (ft)', required: true },

  commonPipeDto: { label: 'Pipe' },
  extraPipeBeyondToe: { label: 'Extra Pipe Beyond Toe (ft)' },
  skewAngle: { label: 'Skew Angle (degrees)' },

  earthWorksDto: { label: 'Earthworks' },
  upStream: { label: 'Side Slopes Up-stream (ft/ft)' },
  downStream: { label: 'Side Slopes Down-stream (ft/ft)' },

  commonSideSlopeDto: { label: '' },
  topElev: { label: 'Top Elevation (ft)', required: true },
  dsTopElev: { label: 'DS Toe Elevation (ft)' }, // ?

  // Orifice Flow
  diameterDto: { label: 'Diameter', tab: true },
  orificeCoefficient: { required: true, label: 'Orifice Coefficient (C)', errorCode: 'Common_10'},
  head: { required: true, label: 'Head on Orifice (ft)', errorCode: 'Common_10' },
  orificeDiameter: { required: true, label: 'Diameter of Orifice (in)', errorCode: 'Common_10' },

  areaDto: { label: 'Area', tab: true },
  orificeArea: {
    required: true,
    label: 'Area of Orifice (sq in)',
    errorCode: 'Common_10',
  },
  q: { label: 'Orifice Capacity (cfs)' },
  calDiameter: { hidden: true },

  //  Parabolic
  topWidth: {
    required: true,
    label: 'Top Width (ft)',
    min: 0.01,
    errorCode: 'Common_10',
  },
  depth: {
    required: true,
    label: 'Depth (ft)',
    min: 0.01,
    errorCode: 'Common_10',
  },
  bedSlope: {
    required: true,
    label: 'Bed Slope (ft/ft)',
    step: 0.0001,
    min: 0.0001,
    errorCode: 'Common_10',
    decimalPlaces: 4,
  },
  manningsN: {
    required: true,
    label: "Manning's n",
    step: 0.0001,
    min: 0.0001,
    max: 1.0,
    errorCode: 'Formula_02',
    decimalPlaces: 4,
  },
  hydraulicRadius: { label: 'Hydraulic Radius (ft)' },
  area: { label: 'Area (sq units)', specifyFor: ['Parabolic Channel'], specificUnits: 'ft', replace: 'units'},
  capacity: { label: 'Capacity (cfs)' },
  velocity: { label: 'Velocity (ft/sec)' },
  criticalDepth: { label: 'Critical Depth (ft)' },

  // Pipe Drop
  pipeDropElevationDto: { label: 'Elevations' },
  riserTopElev: { label: 'Riser-Top Elevation (ft)', required: true },
  riserDiameter: { label: 'Riser Diameter (in)', required: true },
  riserLengthBelowInlet: { label: 'Riser Length Below Inlet (in)', required: true },

  // Plunge Pool
  plungePoolElevationsDto: { label: 'Elevations' },
  pipeOutletElev: { label: 'Pipe Outlet Elevation (ft)' },
  channelFlowElev: { label: 'Channel Flow Elevation (ft)' },
  channelBottomElev: { label: 'Channel Bottom Elevation (ft)' },
  plungePoolPipeDto: { label: 'Pipe' },
  maxPipeQ: { label: 'Max Pipe Q (cfs)' },
  poolShapeDto: { label: 'Pool' },
  aveRockSize: { label: 'Average Rock Size (in)' },
  geotextileFilter: { label: 'Geotextile Filter', checkbox: true },
  filterThickness: { label: 'Filter Thickness (in)' },
  overrideSideSlopes: { label: 'Override Side Slopes', checkbox: true },
  withFlow: { label: 'Width Flow (n:1)', disabled: true },
  acrossFlow: { label: 'Across Flow (n:1)', disabled: true },
  poolShape: {
    label: 'Pool Shape',
    options: [
      { name: 'Elliptical1', value: 'Elliptical1' },
      { name: 'Rectangular', value: 'Rectangular' },
    ],
  },

  // Pressure Flow in Pipe
  headDto: { label: 'Head', tab: true },
  headOnPipe: { label: 'Head on Pipe (ft)', required: true },
  entranceLossCoeff: { label: 'Entrance Loss Coefficient (Ke)', min: 0.0, max: 2.0, errorCode: 'Formula_19' },
  bendLossCoeff: { label: 'Bend Loss Coefficient (Kb)', min: 0.0, max: 2.0, errorCode: 'Formula_20' }, //formula_20

  elevationDto: { label: 'Elevations', tab: true },
  waterSurfaceElev: { label: 'Water Surface Elevation (ft)' },
  invertOutletElev: { label: 'Invert Outlet Elevation (ft)' },

  // Rectangular Riser Drop
  riserDto: { label: 'Riser' },
  riserLength: { required: true, label: 'Riser Length (ft)',  errorCode: 'Common_10' },
  riserWidth: { required: true, label: 'Riser Width (ft)',  errorCode: 'Common_10' },
  recRiserDropStructureElevationDto: { label: 'Elevations',  errorCode: 'Common_10' },
  maxPoolElev: { required: true, label: 'Max Pool Elevation (ft)', errorCode: 'Common_10' },
  weirElev: { required: true, label: 'Weir Elevation (ft)',  errorCode: 'Common_10' },
  inletElev: { label: 'Inlet Elevation (ft)' }, // not required
  outletElev: { label: 'Outlet Elevation (ft)' }, // not required
  tailWaterElev: { label: 'Tailwater Elevation (ft)', disabled: true }, // not required
  enableTailWater: { label: 'Enable Tailwater', checkbox: true, checked: false, correspondingField: 'tailWaterElev'}, //capitalization changes for checkbox as well
  recRiserDropPipeDto: { label: 'Pipe' },
  pipeDiameter: {
    required: true,
    label: 'Pipe Diameter (in)',
    errorCode: 'Formula_07',
    min: 0.02,
  },
  pipeLength: { required: true, label: 'Pipe Length (ft)', min: 0.01, errorCode: 'Common_10' },

  // Straight Drop Inlet
  weirLength: { label: 'Weir Length (ft)', required: true },
  sillElevation: { label: 'Sill Elevation (ft)' },

  // Trapezoidal
  bottomWidth: { label: 'Bottom Width (ft)', required: true, errorCode: 'Common_10' },
  sideSlopZ1: { label: "Side Slope 'Z1' (ft/ft)" },
  sideSlopZ2: { label: "Side Slope 'Z2' (ft/ft)" },
  capacityQ: { label: 'Capacity Q (cfs)' },
  valocity: { label: 'Velocity (ft/sec)' }, //double check velocity default value

  // Water Control
  inlineWaterControlElevationDto: { label: 'Elevations' },
  // { id: 'maxPoolElev', label: '' }, // different label Maximum Pool Elevation (ft)
  pipeInletElev: { label: 'Pipe Inlet Elevation (ft)', required: true },
  structureInvertElev: { label: 'Structure Inlet Elevation (ft)' },
  commonOutletDto: { label: 'Outlet' },
  commonInletDto: { label: 'Inlet' },
  inletEntry: {
    label: 'Inlet Entry',
    required: true,
    options: [
      { name: 'ProjectingGrooveEnd', value: 'ProjectingGrooveEnd' },
      { name: 'ProjectingSquareEnd', value: 'ProjectingSquareEnd' },
      { name: 'ProjectingThinEdge', value: 'ProjectingThinEdge' },
      { name: 'HeadwallGrooveEnd', value: 'HeadwallGrooveEnd' },
      { name: 'HeadwallRoundedEnd', value: 'HeadwallRoundedEnd' },
      { name: 'HeadwallSquareEnd', value: 'HeadwallSquareEnd' },
      { name: 'MitreSquare', value: 'MitreSquare' },
    ],
  },

  // V-Notch Weir
  headOnWeir: { label: 'Head on Weir (ft)', required: true, errorCode: 'Common_10' },

  // Weir Flow
  weirCoefficient: {
    label: 'Weir Coeficient (C)',
    required: true,
    options: [{ name: '3.1(Broad-Crested)', value: 3.1 }],
  },
  lengthOfWeir: { label: 'Length of Weir (ft)' },
  headOfWeir: { label: 'Head of Weir (ft)' },

  // Results
  seepagePath: { label: 'Seepage Path (ft)' },
  lengthOfPipe: { label: 'Length of Pipe (ft)' },
  message: { label: 'Message' },
  riserHeight: { label: 'Riser Height' }, // ?
  //Prismatoid, frustum of a pyramid result(area1, area2)
  areaMid: { label: 'Area Mid',required: true, min: 0.01, errorCode: 'Common_10' },
  // Should have units in Frustum of a Cone, but not Prismatoid
  area2: { label: 'Area 2 (sq units)',required: true, min: 0.01, errorCode: 'Common_10', specifyFor: ['Prismatoid'], specificUnits: '', replace: '(sq units)' },
  area1: { label: 'Area 1 (sq units)',required: true, min: 0.01, errorCode: 'Common_10', specifyFor: ['Prismatoid'], specificUnits: '', replace: '(sq units)' },
  // Pump Drainage
  pumpDrainageElevationDto: { label: 'Elevations' },
  startLevel: { label: 'Start Level (ft)' },
  stopLevel: { label: 'Stop Level (ft)' },
  sumpArea: { label: 'Sump Area (ft)' },
  drainedArea: {label: 'Drained Area (ac)' },
  drainageCoeffs: {label: 'Drainage Coefficient (in/ day)' },
  saftyFactors: {label: 'Safety Factor' },

  //Circle and Sphere
  diameter : {label : 'Diameter ', required : true, min: 0.01, errorCode: 'Common_10'},
  circumference : {label : 'Circumference (units)'},

  // Parallelogram, Frustum of pyramid(a,b,height)
  a: { label: "Side 'a'", required: true, min: 0.01, errorCode: 'Common_10' },
  b: { label: "Side 'b'", required: true, min: 0.01, errorCode: 'Common_10' },
  h: { label: "Height", required: true, min: 0.01, errorCode: 'Common_10' },
  height: { label: "Height", required: true, min: 0.01, errorCode: 'Common_10' },
  d1: { label: "Diagonal 1 (units)",},
  d2: { label: "Diagonal 2 (units)",},
  theta: { label: "Theta°",},

  // Parabola
  dep: { label: 'Depth', required: true, min: 0.01, errorCode: 'Common_10' },
  topW: { label: 'Top Width', required: true, min: 0.01, errorCode: 'Common_10' },

  // Frustrum of a Cone, frustum of a pyramid result(volume)
  diameter1: { label: "Diameter 1", required: true, min: 0.01, errorCode: 'Common_10'},
  diameter2: { label: "Diameter 2", required: true, min: 0.01, errorCode: 'Common_10'},
  volume: { label: "Volume (cu units)"},

  // Sphere
  surfaceArea:{ label: "Surface Area (sq units)"},
  //Rectangular Parallelepiped
  diagonal:{label:"Diagonal (units)"},
  sideA:{label: "Side 'a'", required: true, min: 0.01, errorCode: 'Common_10' },
  sideB:{label: "Side 'b'", required: true, min: 0.01, errorCode: 'Common_10' },
  sideC:{label: "Side 'c'", required: true, min: 0.01, errorCode: 'Common_10' },
  // frustum of a pyramid
  nOfSides:{label:"Number of sides", required: true, min: 0.01, errorCode: 'Common_10'}
};
